module.exports = __webpack_public_path__ + "static/media/payment@2x.134cc1a8.png";